import { render, staticRenderFns } from "./Authenticate.vue?vue&type=template&id=c0c60fe0&scoped=true&"
import script from "./Authenticate.vue?vue&type=script&lang=js&"
export * from "./Authenticate.vue?vue&type=script&lang=js&"
import style0 from "./Authenticate.vue?vue&type=style&index=0&id=c0c60fe0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0c60fe0",
  null
  
)

export default component.exports